import api from './api';

export const settingsService = {
  async getDeliverySettings() {
    const response = await api.get('/settings/delivery');
    return response.data;
  },

  async updateDeliverySettings(payload) {
    const response = await api.post('/settings/delivery', payload);
    return response.data;
  },
};


